import { configureStore } from '@reduxjs/toolkit';
import { createRouterMiddleware } from '@lagunovsky/redux-react-router';

import { history } from '@xarvio/frontend-core-platform/lib/browserHistory';
import { rootReducer } from './rootReducer';

export const reduxStore = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(createRouterMiddleware(history)),
});

export default reduxStore;
